import * as React from "react";
import PropTypes from "prop-types";
import { IconPasswordNotVisible, IconPasswordVisible } from "../../../Icons";
import NoStyleButton from "../../../NoStyleButton";
import prefixStyles from "../../../utils/prefixStyles";

const buttonStyle = prefixStyles({ display: "inline-flex" });

export default class RevealPasswordIcon extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(["password", "text"]),
    onClick: PropTypes.func,
  };

  render() {
    const { type, onClick } = this.props;
    const isPassword = type === "password";

    const icon = isPassword ? (
      <IconPasswordNotVisible height="1.1em" width="1.1em" />
    ) : (
      <IconPasswordVisible height="1.1em" width="1.1em" />
    );

    return (
      <NoStyleButton
        aria-label={isPassword ? "Show password" : "Hide password"}
        // Intentionally using an onClick handler here instead of a Tappable due
        // to conflicts with special focus management with password reveal in
        // fields; see InputField#_handleRevealPassword for context.
        // eslint-disable-next-line nexia/prefer-tappable
        onClick={onClick}
        aria-pressed={isPassword}
        style={buttonStyle}
      >
        {icon}
      </NoStyleButton>
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/Form/fields/FormFieldIcons/RevealPasswordIcon.jsx